module.exports = __webpack_public_path__ + "img/newicon7on.1f84d8e7.svg";